import React from 'react'
import moment from 'moment'

const MONTHS = [
  { value: 0, label: 'January' },
  { value: 1, label: 'February' },
  { value: 2, label: 'March' },
  { value: 3, label: 'April' },
  { value: 4, label: 'May' },
  { value: 5, label: 'June' },
  { value: 6, label: 'July' },
  { value: 7, label: 'August' },
  { value: 8, label: 'September' },
  { value: 9, label: 'October' },
  { value: 10, label: 'November' },
  { value: 11, label: 'December' },
]

const generateYears = () => {
  const currentYear = new Date().getFullYear()
  const years = []
  for (let i = currentYear; i >= currentYear - 5; i--) {
    years.push(i)
  }
  return years
}

const generateDays = (year, month) => {
  // Use moment to get the number of days in the month for the given year
  const daysInMonth = moment().year(year).month(month).daysInMonth()
  const days = []
  for (let i = 1; i <= daysInMonth; i++) {
    days.push(i)
  }
  return days
}

const FILTER_TYPES = [
  { value: 'year', label: 'Year' },
  { value: 'month', label: 'Month' },
  { value: 'day', label: 'Day' },
]

const EMAIL_TYPE_LABELS = {
  confirm: 'Confirmation',
  cancel: 'Cancellation',
  refund: 'Refund',
  complete: 'Completion',
  extraCharge: 'Extra Charge',
  noShow: 'No Show',
  invoice: 'Invoice',
  invoice_warning_1st: '1st Invoice Warning',
  invoice_warning_2nd: '2nd Invoice Warning',
  invoice_warning_3rd: '3rd Invoice Warning',
  low_balance: 'Low Balance Alert',
  report: 'Report',
  other: 'Other',
}

const ACCOUNT_TYPE_LABELS = {
  noreply: 'noreply@coralphuket.com',
  reservation: 'reservation@coralphuket.com',
  accounting: 'accounting@coralphuket.com',
}

export default function EmailUsageReport({
  filter,
  onFilterChange,
  reportData,
  error,
  isLoading,
}) {
  const years = generateYears()
  const days = generateDays(filter.year, filter.month)

  // Handler to ensure day is valid when month/year changes
  const handleYearChange = (newYear) => {
    onFilterChange('year', newYear)
    // Check if current day is valid for the selected month/year
    const daysInNewMonth = moment()
      .year(newYear)
      .month(filter.month)
      .daysInMonth()
    if (filter.day > daysInNewMonth) {
      onFilterChange('day', daysInNewMonth)
    }
  }

  const handleMonthChange = (newMonth) => {
    onFilterChange('month', newMonth)
    // Check if current day is valid for the selected month/year
    const daysInNewMonth = moment()
      .year(filter.year)
      .month(newMonth)
      .daysInMonth()
    if (filter.day > daysInNewMonth) {
      onFilterChange('day', daysInNewMonth)
    }
  }

  return (
    <div className="p-6">
      <div className="flex items-center gap-4 mb-4">
        <button
          onClick={() => window.history.back()}
          className="flex items-center gap-2 px-4 py-2 text-gray-600 bg-transparent border-none hover:bg-gray-100 rounded-md"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            className="w-5 h-5"
          >
            <path
              fillRule="evenodd"
              d="M7.72 12.53a.75.75 0 010-1.06l7.5-7.5a.75.75 0 111.06 1.06L9.31 12l6.97 6.97a.75.75 0 11-1.06 1.06l-7.5-7.5z"
              clipRule="evenodd"
            />
          </svg>
          Back
        </button>
        <h1 className="text-3xl font-bold my-0">Email Usage Report</h1>
      </div>
      <hr className="mb-6" />

      <div>
        <div className="flex items-end gap-4">
          <div className="w-32">
            <label className="block text-xs font-semibold uppercase tracking-wide text-gray-500 mb-2">
              Filter By
            </label>
            <select
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              value={filter.filterBy}
              onChange={(e) => onFilterChange('filterBy', e.target.value)}
            >
              {FILTER_TYPES.map((type) => (
                <option key={type.value} value={type.value}>
                  {type.label}
                </option>
              ))}
            </select>
          </div>

          {filter.filterBy === 'year' && (
            <div className="flex-1">
              <label className="block text-xs font-semibold uppercase tracking-wide text-gray-500 mb-2">
                Year
              </label>
              <select
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                value={filter.year}
                onChange={(e) =>
                  onFilterChange('year', parseInt(e.target.value))
                }
              >
                {years.map((year) => (
                  <option key={year} value={year}>
                    {year}
                  </option>
                ))}
              </select>
            </div>
          )}

          {filter.filterBy === 'month' && (
            <div className="flex-1 flex gap-4">
              <div className="flex-1">
                <label className="block text-xs font-semibold uppercase tracking-wide text-gray-500 mb-2">
                  Year
                </label>
                <select
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  value={filter.year}
                  onChange={(e) =>
                    onFilterChange('year', parseInt(e.target.value))
                  }
                >
                  {years.map((year) => (
                    <option key={year} value={year}>
                      {year}
                    </option>
                  ))}
                </select>
              </div>

              <div className="flex-1">
                <label className="block text-xs font-semibold uppercase tracking-wide text-gray-500 mb-2">
                  Month
                </label>
                <select
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  value={filter.month}
                  onChange={(e) =>
                    onFilterChange('month', parseInt(e.target.value))
                  }
                >
                  {MONTHS.map((month) => (
                    <option key={month.value} value={month.value}>
                      {month.label}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          )}

          {filter.filterBy === 'day' && (
            <div className="flex-1 flex gap-4">
              <div className="flex-1">
                <label className="block text-xs font-semibold uppercase tracking-wide text-gray-500 mb-2">
                  Year
                </label>
                <select
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  value={filter.year}
                  onChange={(e) => handleYearChange(parseInt(e.target.value))}
                >
                  {years.map((year) => (
                    <option key={year} value={year}>
                      {year}
                    </option>
                  ))}
                </select>
              </div>

              <div className="flex-1">
                <label className="block text-xs font-semibold uppercase tracking-wide text-gray-500 mb-2">
                  Month
                </label>
                <select
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  value={filter.month}
                  onChange={(e) => handleMonthChange(parseInt(e.target.value))}
                >
                  {MONTHS.map((month) => (
                    <option key={month.value} value={month.value}>
                      {month.label}
                    </option>
                  ))}
                </select>
              </div>

              <div className="flex-1">
                <label className="block text-xs font-semibold uppercase tracking-wide text-gray-500 mb-2">
                  Day
                </label>
                <select
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  value={filter.day}
                  onChange={(e) =>
                    onFilterChange('day', parseInt(e.target.value))
                  }
                >
                  {days.map((day) => (
                    <option key={day} value={day}>
                      {day}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          )}
        </div>
      </div>

      <div>
        <div>
          {isLoading && (
            <div className="text-center py-10">
              <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
              <p className="mt-4 text-gray-600">Loading email usage data...</p>
            </div>
          )}

          {error && !isLoading && (
            <div className="text-center py-10">
              <div className="text-red-600 mb-4">
                <svg
                  className="mx-auto h-12 w-12"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
              </div>
              <h4 className="text-xl font-semibold text-gray-800 mb-2">
                Error Loading Report
              </h4>
              <p className="text-gray-600">{error}</p>
            </div>
          )}

          {!isLoading && !error && reportData && (
            <div>
              <div>
                <h3 className="text-base font-semibold">Overall</h3>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
                <div className="p-4 rounded-lg border border-solid border-gray-300">
                  <div className="text-xs font-semibold text-gray-600 mb-2 uppercase tracking-wide">
                    Total Sent
                  </div>
                  <div className="text-4xl font-bold">
                    {reportData.summary?.totalSent || 0}
                  </div>
                </div>
                <div className="p-4 rounded-lg border border-solid border-gray-300">
                  <div className="text-xs font-semibold text-gray-600 mb-2 uppercase tracking-wide">
                    Total Failed
                  </div>
                  <div className="text-4xl font-bold">
                    {reportData.summary?.totalFailed || 0}
                  </div>
                </div>
                <div className="p-4 rounded-lg border border-solid border-gray-300">
                  <div className="text-xs font-semibold text-gray-600 mb-2 uppercase tracking-wide">
                    Success Rate
                  </div>
                  <div className="text-4xl font-bold text-green-600">
                    {typeof reportData.summary?.successRate === 'number'
                      ? reportData.summary.successRate.toFixed(1)
                      : 0}
                    %
                  </div>
                </div>
                <div className="p-4 rounded-lg border border-solid border-gray-300">
                  <div className="text-xs font-semibold text-gray-600 mb-2 uppercase tracking-wide">
                    Unique Recipients
                  </div>
                  <div className="text-4xl font-bold">
                    {reportData.summary?.uniqueRecipients || 0}
                  </div>
                </div>
              </div>

              {reportData.byAccount && (
                <div className="mt-6">
                  <div className="space-y-4">
                    {Object.entries(reportData.byAccount).map(
                      ([accountType, accountData]) => (
                        <div key={accountType}>
                          <h5 className="text-base font-semibold mb-4">
                            {ACCOUNT_TYPE_LABELS[accountType] || accountType}
                          </h5>
                          <div className="grid grid-cols-3 gap-4 pb-4 border-b">
                            <div className="p-3 rounded border border-solid border-gray-300">
                              <div className="text-xs font-semibold text-gray-600 mb-2 uppercase tracking-wide">
                                Sent
                              </div>
                              <div className="text-3xl font-bold text-gray-900">
                                {accountData.totalSent}
                              </div>
                            </div>
                            <div className="p-3 rounded border border-solid border-gray-300">
                              <div className="text-xs font-semibold text-gray-600 mb-2 uppercase tracking-wide">
                                Failed
                              </div>
                              <div className="text-3xl font-bold text-gray-900">
                                {accountData.totalFailed}
                              </div>
                            </div>
                            <div className="p-3 rounded border border-solid border-gray-300">
                              <div className="text-xs font-semibold text-gray-600 mb-2 uppercase tracking-wide">
                                Success Rate
                              </div>
                              <div className="text-3xl font-bold text-gray-900">
                                {typeof accountData.successRate === 'number'
                                  ? accountData.successRate.toFixed(1)
                                  : 0}
                                %
                              </div>
                            </div>
                          </div>

                          {accountData.byEmailType &&
                            Object.keys(accountData.byEmailType).length > 0 && (
                              <div>
                                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3">
                                  {Object.entries(accountData.byEmailType).map(
                                    ([emailType, stats]) => (
                                      <div
                                        key={emailType}
                                        className="p-3 rounded border border-solid border-gray-300"
                                      >
                                        <div className="text-xs font-semibold text-gray-600 mb-2 uppercase tracking-wide">
                                          {EMAIL_TYPE_LABELS[emailType] ||
                                            emailType}
                                        </div>
                                        <div className="flex gap-4 text-xs">
                                          <div>
                                            <div className="text-xs tracking-wide text-gray-500">
                                              Sent
                                            </div>{' '}
                                            <div className="font-bold">
                                              {stats.sent}
                                            </div>
                                          </div>
                                          <div>
                                            <div className="text-xs tracking-wide text-gray-500">
                                              Failed
                                            </div>{' '}
                                            <div className="font-bold">
                                              {stats.failed}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    ),
                                  )}
                                </div>
                              </div>
                            )}
                        </div>
                      ),
                    )}
                  </div>
                </div>
              )}

              {reportData.topRecipients &&
                reportData.topRecipients.length > 0 && (
                  <div className="mt-6">
                    <h4 className="text-base font-semibold mb-4">
                      Top Recipients ({reportData.topRecipients.length})
                    </h4>
                    <div className="overflow-x-auto">
                      <table className="min-w-full divide-y divide-gray-200 border">
                        <thead className="bg-gray-50">
                          <tr>
                            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                              Rank
                            </th>
                            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                              Email
                            </th>
                            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                              Email Count
                            </th>
                          </tr>
                        </thead>
                        <tbody className="bg-white divide-y divide-gray-200">
                          {reportData.topRecipients.map((recipient, index) => (
                            <tr key={index} className="hover:bg-gray-50">
                              <td className="px-4 py-3 text-sm text-gray-500 whitespace-nowrap">
                                #{index + 1}
                              </td>
                              <td className="px-4 py-3 text-sm text-gray-900">
                                {recipient.email}
                              </td>
                              <td className="px-4 py-3 text-sm font-semibold text-gray-900">
                                {recipient.count}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}

              {reportData.failedEmails &&
                reportData.failedEmails.length > 0 && (
                  <div className="mt-6">
                    <h4 className="text-lg font-semibold mb-4">
                      Failed Emails ({reportData.failedEmails.length})
                    </h4>
                    <div className="overflow-x-auto">
                      <table className="min-w-full divide-y divide-gray-200 border">
                        <thead className="bg-gray-50">
                          <tr>
                            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                              Date/Time
                            </th>
                            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                              Account
                            </th>
                            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                              Type
                            </th>
                            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                              Recipient
                            </th>
                            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                              Error Message
                            </th>
                          </tr>
                        </thead>
                        <tbody className="bg-white divide-y divide-gray-200">
                          {reportData.failedEmails.map((email, index) => (
                            <tr key={index} className="hover:bg-gray-50">
                              <td className="px-4 py-3 text-sm text-gray-900 whitespace-nowrap">
                                {moment(email.sentAt).format(
                                  'MMM D, YYYY HH:mm',
                                )}
                              </td>
                              <td className="px-4 py-3 text-sm text-gray-900">
                                {ACCOUNT_TYPE_LABELS[email.accountType] ||
                                  email.accountType}
                              </td>
                              <td className="px-4 py-3 text-sm text-gray-900">
                                {EMAIL_TYPE_LABELS[email.emailType] ||
                                  email.emailType}
                              </td>
                              <td className="px-4 py-3 text-sm text-gray-900">
                                {email.recipient}
                              </td>
                              <td className="px-4 py-3 text-sm text-red-600">
                                {email.errorMessage}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}
            </div>
          )}

          {!isLoading && !error && !reportData && (
            <div className="text-center py-10 text-gray-600">
              <h4 className="text-2xl font-bold mb-5 text-gray-800">
                Email Usage Report
              </h4>
              <p className="text-base mb-4">
                Track and analyze email sending patterns across all department
                email accounts.
              </p>
              <p className="text-base mb-5">
                Select a{' '}
                {filter.filterBy === 'year'
                  ? 'year'
                  : filter.filterBy === 'month'
                    ? 'month'
                    : 'day'}{' '}
                and generate a report to view:
              </p>
              <ul className="text-left max-w-2xl mx-auto space-y-3 list-disc list-inside">
                <li>
                  Total emails sent by each account (noreply, reservation,
                  accounting)
                </li>
                <li>
                  Email types breakdown (confirmation, cancellation, invoice,
                  etc.)
                </li>
                <li>Failed email sends with error details</li>
                <li>Success rate and unique recipient counts</li>
              </ul>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
